import { render } from "./CustomerModal.vue?vue&type=template&id=ab699490&scoped=true"
import script from "./CustomerModal.vue?vue&type=script&lang=js"
export * from "./CustomerModal.vue?vue&type=script&lang=js"

import "./CustomerModal.vue?vue&type=style&index=0&id=ab699490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab699490"]])

export default __exports__